import AddAPhotoIcon from '@mui/icons-material/AddAPhoto'
import axios from 'axios'
import { Box, Button, Checkbox, Grid, MenuItem, TextField, Typography } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../../libs/contexts/authContext'
import {
  filterNonAlphabets,
  filterNonDigits,
  isValidEmail,
  isValidPhoneNumber,
  isValidUrl,
  phoneNumberFormatter,
} from '../../libs/utils'
import { getZipCodes, states, whichStates, generateUniqueFileName } from './utils'
import { useDispatch } from 'react-redux'
import { getPresignedUrl } from '../../store/actions/authActions'

function ThirdRegisterStep({
  registrationForm,
  setRegistrationForm,
  handleRegistrationFormChange,
  personalAddress,
  workAddress,
  setPersonalAddress,
  sameAddress,
  setSameAddress,
  handleSubmit,
}) {
  const dispatch = useDispatch()
  const [profilePic, setProfilePic] = useState(null)
  const { invalidUrl } = useContext(AuthContext)
  // const [sameAddress, setSameAddress] = useState(false);
  const [agreedCheckbox, setAgreedCheckbox] = useState(false)
  const [errorTree, setErrorTree] = useState({
    firstName: false,
    lastName: false,
    phoneNumber: false,
    personalEmail: false,
    personalWebsite: false,
    zipCode: false,
    agreeToTerms: false,
  })
  const { personalPhone, personalEmail, personalWebsite, firstName, lastName } = registrationForm
  const { zipCode, state } = personalAddress

  useEffect(() => {
    // if isSame box is checked, clone the object from workAddress; otherwise reset it
    const cloneAddressIfSame = () => {
      setPersonalAddress((prev) =>
        sameAddress ? { ...workAddress } : Object.fromEntries(Object.keys(prev).map((k) => [k, '']))
      )
    }
    cloneAddressIfSame()
  }, [sameAddress, workAddress, setPersonalAddress])

  useEffect(() => {
    if (zipCode !== '' && zipCode.length < 5) {
      setErrorTree((prev) => ({ ...prev, zipCode: true }))
      return
    }
    const validateZipCode = () => {
      const statesArr = whichStates(zipCode)
      if (statesArr.findIndex((s) => s === state) === -1) {
        setErrorTree((prev) => ({ ...prev, zipCode: true }))
        return
      }
      const targetCodes = getZipCodes(state)
      setErrorTree((prev) => ({
        ...prev,
        zipCode: targetCodes.findIndex((c) => c === zipCode) === -1,
      }))
    }
    if (state) {
      validateZipCode()
    }
  }, [state, zipCode])

  const handleImageUploading = async (e) => {
    if (!e.target.files || e.target.files.length <= 0) return
    const file = e.target.files[0]
    setProfilePic(URL.createObjectURL(file))

    // TODO: uncomment this after `getPresigned` api is deployed
    // const imageName = encodeURIComponent(file.name);
    // const fileName = generateUniqueFileName(imageName);

    // const input = {
    //   prsCode: '3209254', // dummy prs code
    //   fileName,
    //   fileType: file.type,
    // };
    // const res = await dispatch(getPresignedUrl(input));
    // const { data: parsedData } = res;
    // if (!parsedData) return;

    // const blobForm = new FormData();
    // Object.entries({ ...parsedData.fields, file }).forEach(([key, value]) => {
    //   blobForm.append(key, value);
    // });
    // await axios.post(parsedData.url, blobForm);

    // setRegistrationForm((prev) => ({
    //   ...prev,
    //   profilePhoto: `${parsedData.url}/${fileName}`,
    // }));
  }

  const handleFormChange = ({ target: { name, value } }) => {
    switch (name) {
      case 'firstName':
      case 'lastName':
        const nameValue = filterNonAlphabets(value)
        setRegistrationForm((prev) => ({ ...prev, [name]: nameValue }))
        break
      case 'personalWebsite':
        setRegistrationForm((prev) => ({ ...prev, [name]: value }))
        if (nameValue.length >= 5) {
          setErrorTree((prev) => ({
            ...prev,
            personalWebsite: !isValidUrl(value),
          }))
        }
        break
      case 'personalEmail':
        setRegistrationForm((prev) => ({ ...prev, [name]: value }))
        if (value.length >= 5) {
          setErrorTree((prev) => ({
            ...prev,
            personalEmail: !isValidEmail(value),
          }))
        }
        break
      case 'zipCode':
        const filteredZipCode = filterNonDigits(value)
        if (filteredZipCode.length === 5) {
          setErrorTree((prev) => ({ ...prev, zipCode: false }))
        }
        setPersonalAddress((prev) => ({ ...prev, zipCode: filteredZipCode }))
        break
      default:
        setPersonalAddress((prev) => ({ ...prev, [name]: value }))
        break
    }
  }

  const handleBlur = ({ target: { name, value } }) => {
    switch (name) {
      case 'firstName':
      case 'lastName':
        if (value === '') {
          setErrorTree({ ...errorTree, [name]: true })
        }
        break
      case 'personalPhone':
        setErrorTree((prev) => ({
          ...prev,
          phoneNumber: value === '' ? false : !isValidPhoneNumber(value),
        }))
        break
      case 'personalEmail':
        setErrorTree((prev) => ({
          ...prev,
          personalEmail: personalEmail === '' ? false : !isValidEmail(value),
        }))
        break
      case 'personalWebsite':
        setErrorTree((prev) => ({
          ...prev,
          personalWebsite: value === '' ? false : !isValidUrl(value),
        }))
        break
      default:
        break
    }
  }

  const formIsComplete = Boolean(firstName && lastName)
  const errorFree = Object.values(errorTree).every((v) => v === false)

  return (
    <Box component="form" sx={{ '& .MuiTextField-root': { m: 1 } }} noValidate autoComplete="off">
      <Typography align={'left'} sx={registerStepStyle.subheading}>
        Information About You
      </Typography>
      <Grid container spacing={2}>
        <Grid item lg={3} md={3} sm={3} xs={12} align="center">
          <div
            style={{
              backgroundColor: '#E8EBF1',
              border: '1px solid #CBD2DB',
              height: '86px',
              width: '86px',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '5px',
            }}
          >
            {profilePic ? (
              <img
                src={profilePic}
                alt="Profile preview"
                style={{ width: '100%', height: '100%', borderRadius: '50%' }}
              />
            ) : (
              <AddAPhotoIcon sx={{ color: '#7B8A9E', height: '40%', width: '40%' }}></AddAPhotoIcon>
            )}
          </div>
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={12} sx={registerStepStyle.photoGrid}>
          <Button component="label" sx={registerStepStyle.photoButton}>
            Upload Photo
            <input name="profilePhoto" type="file" accept="image/*" onChange={handleImageUploading} hidden />
          </Button>
          <Typography fontSize={12} marginTop={'15px'}>
            At least 110 x 110 px JPG or PNG file{' '}
          </Typography>
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <TextField
            id="outlined-disabled"
            label="First Name"
            name="firstName"
            value={firstName}
            placeholder="ex. Jane"
            onChange={handleFormChange}
            onBlur={handleBlur}
            InputLabelProps={{ shrink: true }}
            sx={registerStepStyle.textField}
            error={errorTree.firstName}
            helperText={errorTree.firstName ? 'A first name is required' : ''}
            required
          />
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={12} justify="center" alignItems="center">
          <TextField
            id="outlined-disabled"
            label="Last Name"
            name="lastName"
            value={lastName}
            placeholder="ex. Doe"
            onChange={handleFormChange}
            onBlur={handleBlur}
            InputLabelProps={{ shrink: true }}
            sx={registerStepStyle.textField}
            error={errorTree.lastName}
            helperText={errorTree.lastName ? 'A last name is required' : ''}
            required
          />
        </Grid>
      </Grid>
      <Typography align={'left'} sx={registerStepStyle.subheading}>
        Contact Information
      </Typography>
      <Grid container spacing={2}>
        <Grid item lg={12} md={12} sm={12} xs={12} justify="center" alignItems="center">
          <TextField
            id="outlined-disabled"
            label="Personal Email Address"
            name="personalEmail"
            placeholder="ex. email@email.com"
            InputLabelProps={{ shrink: true }}
            onChange={handleFormChange}
            onBlur={handleBlur}
            error={errorTree.personalEmail}
            helperText={errorTree.personalEmail ? 'Please enter a valid email address' : ''}
            sx={registerStepStyle.textField}
          />
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <TextField
            id="outlined-disabled"
            label="Personal Phone Number"
            name="personalPhone"
            value={phoneNumberFormatter(personalPhone)}
            placeholder="ex. 000-000-000"
            onChange={handleRegistrationFormChange}
            onBlur={handleBlur}
            inputProps={{ maxLength: 10 }}
            InputLabelProps={{ shrink: true }}
            sx={registerStepStyle.textField}
            error={errorTree.phoneNumber}
            helperText={errorTree.phoneNumber ? 'Please enter a valid phone number' : ''}
          />
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <TextField
            id="outlined-disabled"
            name="personalWebsite"
            label="Personal Website"
            placeholder="ex. www.mywebsite.com"
            value={personalWebsite}
            onChange={handleFormChange}
            onBlur={handleBlur}
            InputLabelProps={{ shrink: true }}
            error={errorTree.personalWebsite}
            helperText={errorTree.personalWebsite ? 'Please enter a valid website url' : ''}
            sx={registerStepStyle.textField}
          />
        </Grid>
      </Grid>
      <Typography align={'left'} sx={registerStepStyle.subheading}>
        Home Address
      </Typography>
      <Grid container item xs={12} justifyContent="start" alignItems="center" paddingBottom={'6px'}>
        <Checkbox label="same-address" required onClick={() => setSameAddress(!sameAddress)} />
        <Typography fontSize={'14px'}>Home Address is same as Work Address</Typography>
      </Grid>
      <Grid container spacing={2}>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <TextField
            id="outlined-disabled"
            label="Zip Code"
            placeholder="ex. 33101"
            name="zipCode"
            value={zipCode}
            onChange={handleFormChange}
            inputProps={{ maxLength: 5 }}
            InputLabelProps={{ shrink: true }}
            error={errorTree.zipCode}
            helperText={errorTree.zipCode ? 'Invalid zip code' : ''}
            sx={registerStepStyle.textField}
          />
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12} justify="center" alignItems="center">
          <TextField
            id="outlined-disabled"
            label="Address 1"
            name="address1"
            value={personalAddress.address1}
            onChange={handleFormChange}
            placeholder="ex. 1234 Chance Rd."
            InputLabelProps={{ shrink: true }}
            sx={registerStepStyle.textField}
          />
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <TextField
            id="outlined-disabled"
            label="Address 2"
            name="address2"
            value={personalAddress.address2}
            onChange={handleFormChange}
            placeholder="ex. Apt 111"
            InputLabelProps={{ shrink: true }}
            sx={registerStepStyle.textField}
          />
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <TextField
            id="outlined-disabled"
            label="City"
            name="city"
            value={personalAddress.city}
            onChange={handleFormChange}
            placeholder="ex. Miami"
            InputLabelProps={{ shrink: true }}
            sx={registerStepStyle.textField}
          />
        </Grid>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <TextField
            select
            label="State"
            name="state"
            value={state}
            onChange={handleFormChange}
            sx={registerStepStyle.textField}
          >
            {states.map((state, index) => (
              <MenuItem key={index} value={state}>
                {state}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>

      <Grid container item xs={12} justifyContent="start" alignItems="center">
        <Checkbox
          label="terms-check"
          required
          onClick={() => {
            setAgreedCheckbox(!agreedCheckbox)
            setErrorTree({
              ...errorTree,
              agreeToTerms: !!agreedCheckbox,
            })
          }}
        />
        <Typography>I agree to the </Typography>
        <Button>
          <Typography
            textTransform={'none'}
            sx={{
              textDecoration: 'underline',
              textUnderlineOffset: '2px',
            }}
          >
            {' '}
            <a href="https://www.afficiency.com/terms-of-service" target="_blank" rel="noopener noreferrer">
              Terms of Service
            </a>{' '}
          </Typography>
        </Button>

        <Typography>and</Typography>
        <Button>
          <Typography
            textTransform={'none'}
            sx={{
              textDecoration: 'underline',
              textUnderlineOffset: '2px',
            }}
          >
            {' '}
            <a href="https://www.afficiency.com/privacy-policy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>{' '}
          </Typography>
        </Button>
      </Grid>
      {errorTree.agreeToTerms && (
        <Typography color="error" sx={{ fontSize: 'small' }}>
          You must agree to the terms.
        </Typography>
      )}
      <Button
        sx={registerStepStyle.nextButton}
        onClick={handleSubmit}
        disabled={!formIsComplete || !errorFree || !agreedCheckbox || invalidUrl}
      >
        Create Account
      </Button>
    </Box>
  )
}

export default ThirdRegisterStep

const registerStepStyle = {
  verifyButton: {
    textTransform: 'none',
    width: { lg: '90%', md: '90%', sm: '90%', xs: '60%' },
    height: '40px',
    mt: { sm: '15px', xs: '0px' },
    backgroundColor: '#C4CAF1',
    color: '#3C4FB9',
    borderRadius: '100px',
    '&:hover': {
      backgroundColor: '#9BA5DF',
      color: '#36414E',
    },
    '&:disabled': {
      backgroundColor: '#C4CAF1',
      color: 'white',
      textTransform: 'none',
    },
  },

  nextButton: {
    textTransform: 'none',
    width: { lg: '50%', md: '50%', sm: '50%', xs: '60%' },
    height: '40px',
    backgroundColor: '#3C4FB9',
    color: 'white',
    borderRadius: '100px',
    mt: '10px',
    '&:hover': {
      backgroundColor: '#9BA5DF',
      color: '#36414E',
    },
    '&:disabled': {
      backgroundColor: '#C4CAF1',
      color: 'white',
      textTransform: 'none',
    },
  },

  photoButton: {
    textTransform: 'none',
    width: { lg: '50%', md: '50%', sm: '50%', xs: '60%' },
    height: '40px',
    backgroundColor: '#3C4FB9',
    color: 'white',
    borderRadius: '100px',
    mt: '10px',
    '&:hover': {
      backgroundColor: '#9BA5DF',
      color: '#36414E',
    },
    '&:disabled': {
      backgroundColor: '#C4CAF1',
      color: 'white',
      textTransform: 'none',
    },
    align: 'center',
  },

  photoGrid: {
    display: 'flex',
    alignItems: {
      lg: 'flex-start',
      md: 'flex-start',
      sm: 'flex-start',
      xs: 'center',
    },
    flexDirection: 'column',
  },
  textField: {
    textAlign: 'left',
    backgroundColor: 'white',
    width: '100%',
  },

  subheading: {
    padding: '30px 0px 15px 0px',
  },
}
